import(/* webpackMode: "eager" */ "/vercel/path0/src/app/partnerships/page.tsx");
